import Component from './SideMenu'

export default Component
